import { of } from 'rxjs';
import { ofType } from 'redux-observable';
import { filter, switchMap } from 'rxjs/operators';
import { searchParametersActions, selectLocationType, LocationType } from 'features/searchResultsFacets';
import mapDataSlice from './dataSlice';

const actions = mapDataSlice.actions;
const RECTANGULAR_AREA = LocationType.RectangularArea.toString();

/**
 * Clears site plan state when the user navigates away from a rectangular-area search.
 *
 * Listens for fetchLocations actions and dispatches clearSitePlans + clearInteractiveSitePlans
 * whenever the current location type is NOT rectangularArea.
 *
 * This prevents stale site plan data from persisting across search mode changes.
 */
const cleanupSitePlansEpic = (action$, state$) =>
  action$.pipe(
    ofType(searchParametersActions.fetchLocations.type),
    filter(() => selectLocationType(state$.value) !== RECTANGULAR_AREA),
    switchMap(() =>
      of(
        actions.clearSitePlans(),
        actions.clearInteractiveSitePlans()
      )
    )
  );

export default cleanupSitePlansEpic;
